import { useEffect } from "react";
import { useSearch } from "./useSearch";
import { useDispatch } from "react-redux";

export const useValidateReload = (loadings = [], action = null, data = []) => {
  const dispatch = useDispatch();
  const { buildCompLoadings, setSnackbar, clearSnackbar } = useSearch();

  useEffect(() => {
    if (loadings && loadings.length >= 0) {
      buildCompLoadings(loadings);
    }

    if (typeof action === "function" && (!data || data.length === 0)) {
      try {
        dispatch(action());
      } catch (error) {
        setSnackbar("Error al crear estados de carga", "warning");
        console.error("useValidateReload dispatch error:", error);
      }
    }

    return () => {
      buildCompLoadings([]);
      clearSnackbar();
    };
  }, []);
};
